<template>
  <div id="myGoodsDetail" style="height: calc(100% - 72px)">
    <div
      style="
        width: 100%;
        height: 100%;
        background-color: white;
        margin-top: 32px;
        padding-bottom: 40px;
      "
    >
      <div style="background-color: #fff">
        <allMallSerch
          ref="allMallSerch"
          style="border-bottom: 1px solid #e6e6e6"
        ></allMallSerch>
        <div style="width: 1300px; margin: auto; padding-bottom: 100px">
          <div class="goodsTopLaDiv">
            <div class="goodsTopLaDiv_left">
              <div>
                <img
                  :src="
                    goodDetail.imgList &&
                    goodDetail.imgList[selectImgIndex] &&
                    goodDetail.imgList[selectImgIndex].url
                  "
                />
              </div>
              <div class="goImg">
                <span class="pre" @click="moveGoImg('pre')" v-text="'<'"></span>
                <div
                  class="goImg_uiWrapper"
                  :style="{ left: leftOffset + 'px' }"
                >
                  <ul>
                    <template v-for="(item, index) in goodDetail.imgList || []">
                      <li
                        :key="index"
                        :class="[
                          selectImgIndex == index ? 'goImg_item-active' : '',
                        ]"
                      >
                        <img
                          @click="hundleGoImgItemClick(index)"
                          :src="item.url"
                        />
                      </li>
                    </template>
                  </ul>
                </div>
                <span
                  class="next"
                  @click="moveGoImg('next')"
                  v-text="'>'"
                ></span>
              </div>
              <!--              <div class="c_p">-->
              <!--                <i class="icon iconfont iconfenxiang"></i>-->
              <!--                <span>分享商品</span>-->
              <!--              </div>-->
            </div>
            <div class="goodsTopLaDiv_right">
              <h1 class="f_w m_b_10">
                {{ goodDetail.name }} - {{ goodDetail.categorySecondName }} -
                {{ goodDetail.guige }}
              </h1>
              <div class="allDiv_lr">
                <ul>
                  <li
                    class="w100"
                    style="
                      border-bottom: 1px solid #f0f0f0;
                      padding-bottom: 20px;
                    "
                  >
                    <span class="colorGray959595" style="vertical-align: bottom"
                      >含税价格</span
                    >
                    <div class="d_inline_flex w100">
                      <div>
                        <span
                          v-if="
                            goodDetail.settlementType === '3' ||
                            goodDetail.settlementType === '1'
                          "
                          class="m_r_10"
                        >
                          <span>理计：</span>
                          <abbr class="colorReded222c f_w">￥</abbr>
                          <abbr
                            class="colorReded222c font28 f_w"
                            style="vertical-align: bottom"
                            >{{
                              baigangToken
                                ? goodDetail.lisuanPrice
                                : "**"
                            }}</abbr
                          >
                          <abbr class="colorGray959595">/吨</abbr>
                        </span>
                        <span
                          v-if="
                            goodDetail.settlementType === '3' ||
                            goodDetail.settlementType === '2'
                          "
                          class="m_r_10"
                        >
                          <span>磅计：</span>
                          <abbr class="colorReded222c f_w">￥</abbr>
                          <abbr
                            class="colorReded222c font28 f_w"
                            style="vertical-align: bottom"
                            >{{
                              baigangToken
                                ? goodDetail.price
                                : "**"
                            }}</abbr
                          >
                          <abbr class="colorGray959595">/吨</abbr>
                        </span>
                        <!--                        <span class="m_r_10"><abbr>09-12 14:03</abbr><abbr class="colorGray959595">更新</abbr></span>-->
                      </div>
                      <div class="d_inline_flex t_c">
                        <div>
                          <p class="font20 f_w">{{ goodDetail.salesVolume }}</p>
                          <p class="colorGray959595">已售</p>
                        </div>
                        <!--                        <div>-->
                        <!--                          <p><span class="font20 f_w" style="vertical-align: bottom">15</span><span>号</span></p>-->
                        <!--                          <p class="colorGray959595">当月开票</p>-->
                        <!--                        </div>-->
                      </div>
                    </div>
                  </li>
                  <li class="w100">
                    <span class="colorGray959595" style="vertical-align: bottom"
                      >仓库</span
                    >
                    <div class="">
                      <span class="m_r_20">{{ nowWareData.region }}</span>
                      <span class="m_r_10">{{ nowWareData.name }}</span>
                      <i
                        @click="showDetailFun"
                        class="icon colorBlue00A6EC iconfont iconxiangqing"
                        style="font-size: 12px"
                      ></i>
                    </div>
                  </li>
                  <li class="w100">
                    <span class="colorGray959595" style="vertical-align: bottom"
                      >服务</span
                    >
                    <div class="d_inline_flex w100">
                      <div>
                        <span class="m_r_20"
                          ><i class="icon iconfont iconziti m_r_5"></i
                          ><abbr>自提</abbr></span
                        >
                        <!--                        <span class="m_r_20"><i class="icon iconfont iconpeisong m_r_5"></i><abbr>商家配送</abbr></span>-->
                        <!--                        <span class="m_r_20"><i class="icon iconfont iconicon_meitanjiagongpin m_r_5"></i><abbr>加工</abbr></span>-->
                      </div>
                      <div>
                        <!--                        <span><abbr class="m_r_5">服务详情</abbr><i class="icon iconfont iconxiangqing" style="font-size: 12px"></i></span>-->
                      </div>
                    </div>
                  </li>
                  <li class="w100">
                    <span class="colorGray959595" style="vertical-align: bottom"
                      >开票</span
                    >
                    <div class="d_inline_flex w100">
                      <div>
                        <!--                        <span class="m_r_20"><i class="icon iconfont icondui1 m_r_5"></i><abbr>当月15日开票</abbr></span>-->
                        <span class="m_r_20"
                          ><i class="icon iconfont icondui1 m_r_5"></i
                          ><abbr>一票制</abbr></span
                        >
                        <!--                        <span class="m_r_20"><i class="icon iconfont icondui1 m_r_5"></i><abbr>多票制</abbr></span>-->
                      </div>
                      <div>
                        <!--                        <span><abbr class="m_r_5">开票详情</abbr><i class="icon iconfont iconxiangqing" style="font-size: 12px"></i></span>-->
                      </div>
                    </div>
                  </li>
                  <li class="w100">
                    <span class="colorGray959595" style="vertical-align: bottom"
                      >吊费</span
                    >
                    <div>
                      <!--                      <span class="m_r_20">-->
                      <!--&lt;!&ndash;                        <i class="icon iconfont iconduihua m_r_5 colorReded222c"></i>&ndash;&gt;-->
                      <!--                        <abbr>立即询价</abbr>-->
                      <!--                      </span>-->
                      <span class="colorRed"
                        >￥{{
                          baigangToken ? (nowWareData && nowWareData.hoistingFee) || 0 : '**'
                        }}</span
                      >
                      <span> / t</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="allDiv_lr">
                <ul>
                  <li class="w100">
                    <span class="colorGray959595" style="vertical-align: middle"
                      >规格重量</span
                    >
                    <div class="d_inline_flex w100">
                      <div
                        v-if="
                          goodDetail.settlementType === '3' ||
                          goodDetail.settlementType === '1'
                        "
                      >
                        <p>{{ baigangToken ? goodDetail.lisuanWeight.toFixed(2) : '**' }}吨</p>
                        <!--                        <p class="colorReded222c">￥{{ goodDetail.lisuanPrice }}/吨</p>-->
                      </div>
                      <div
                        v-if="
                          goodDetail.settlementType === '3' ||
                          goodDetail.settlementType === '2'
                        "
                      >
                        <p>{{ baigangToken ? goodDetail.weight.toFixed(2) : '**' }}吨</p>
                        <!--                        <p class="colorReded222c">￥{{ goodDetail.price }}/吨</p>-->
                      </div>
                      <div class="d_inline_flex w50">
                        <span></span>
                        <div class="CalculateDiv">
                          <span @click="countNum('reduce')">-</span>
                          <div>
                            <input
                              readonly="readonly"
                              v-model="goodDetail.amount"
                              type="number"
                            />
                          </div>
                          <span @click="countNum('add')">+</span>
                        </div>
                        <span class="colorGray959595"
                          >{{
                            baigangToken
                              ? goodDetail.skuList[0].stock
                              : "**"
                          }}件可售</span
                        >
                      </div>
                    </div>
                  </li>
                  <li
                    v-if="
                      goodDetail.settlementType === '3' ||
                      goodDetail.settlementType === '1'
                    "
                    class="w100"
                  >
                    <span class="colorGray959595" style="vertical-align: bottom"
                      >理计合计</span
                    >
                    <div>
                      <span class="m_r_20"
                        ><abbr>已选</abbr
                        ><abbr
                          class="font20 colorReded222c"
                          style="vertical-align: bottom"
                          >{{ this.goodDetail.amount }}</abbr
                        ><abbr>件</abbr></span
                      >
                      <span class="m_r_20"
                        ><abbr
                          class="font20 colorReded222c"
                          style="vertical-align: bottom"
                          >{{
                            baigangToken ? parseFloat(
                              (this.goodDetail.lisuanWeight *
                                this.goodDetail.amount)
                            ).toFixed(2) : '**'
                          }}</abbr
                        ><abbr>吨</abbr></span
                      >
                      <span
                        ><abbr>共</abbr><abbr class="colorReded222c">￥</abbr
                        ><abbr
                          class="font20 colorReded222c"
                          style="vertical-align: bottom"
                          >{{
                            baigangToken
                              ? parseFloat(
                                  (this.goodDetail.lisuanPrice *
                                    this.goodDetail.amount) * goodDetail.lisuanWeight
                                ).toFixed(2)
                              : "**"
                          }}</abbr
                        ></span
                      >
                    </div>
                  </li>
                  <li
                    v-if="
                      goodDetail.settlementType === '3' ||
                      goodDetail.settlementType === '2'
                    "
                    class="w100"
                  >
                    <span class="colorGray959595" style="vertical-align: bottom"
                      >磅计合计</span
                    >
                    <div>
                      <span class="m_r_20"
                        ><abbr>已选</abbr
                        ><abbr
                          class="font20 colorReded222c"
                          style="vertical-align: bottom"
                          >{{ this.goodDetail.amount }}</abbr
                        ><abbr>件</abbr></span
                      >
                      <span class="m_r_20"
                        ><abbr
                          class="font20 colorReded222c"
                          style="vertical-align: bottom"
                          >{{
                            baigangToken ? parseFloat(
                              this.goodDetail.weight * this.goodDetail.amount
                            ).toFixed(2) : '**'
                          }}</abbr
                        ><abbr>吨</abbr></span
                      >
                      <span
                        ><abbr>共</abbr><abbr class="colorReded222c">￥</abbr
                        ><abbr
                          class="font20 colorReded222c"
                          style="vertical-align: bottom"
                          >{{
                            baigangToken
                              ? parseFloat(
                                  this.goodDetail.price * this.goodDetail.amount * this.goodDetail.weight
                                ).toFixed(2)
                              : "**"
                          }}</abbr
                        ></span
                      >
                    </div>
                  </li>
                  <li class="w100">
                    <span style="visibility: hidden">在线支付</span>
                    <div>
                      <!--                      <button v-if="isRegister" class="gmButton m_r_20"><span>立即购买</span></button>-->
                      <button
                        @click="toLogin"
                        v-if="!isRegister"
                        class="gmButton m_r_20"
                      >
                        <span>立即登录</span>
                      </button>
                      <button
                        @click="addToShopCar"
                        v-if="isRegister"
                        class="gwButton"
                        :class="isBishiTime ? 'bishitime' : ''"
                      >
                        <i class="icon iconfont icongouwuche"></i
                        ><span>加入购物车</span>
                      </button>
                    </div>
                  </li>
                  <!-- <li class="w100">
                    <span class="colorGray959595" style="vertical-align: bottom"
                      >在线支付</span
                    >
                    <div>
                      <span class="m_r_20">支付宝</span>
                      <span class="m_r_20">微信</span>
                      <span class="colorGray959595 m_r_20">交易支持</span>
                      <span>担保支付</span>
                    </div>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
          <div class="goodsInfoDiv">
            <nav>
              <span>商品详情</span>
            </nav>
            <div class="allDiv_lr">
              <ul class="allUl_w25">
                <li>
                  <span class="colorGray959595">材质</span>
                  <div class="NoWrap">
                    {{ goodDetail.materialQualityName || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">产地</span>
                  <div class="NoWrap">
                    {{ goodDetail.originPlaceName || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">钢厂</span>
                  <div class="NoWrap">
                    {{ goodDetail.steelMillName || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">长度</span>
                  <div class="NoWrap">
                    {{ goodDetail.length || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">宽度</span>
                  <div class="NoWrap">
                    {{ goodDetail.breadth || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">厚度</span>
                  <div class="NoWrap">
                    {{ goodDetail.depth || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">直径</span>
                  <div class="NoWrap">
                    {{ goodDetail.diameter || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">外径</span>
                  <div class="NoWrap">
                    {{ goodDetail.outDiameter || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">壁厚</span>
                  <div class="NoWrap">
                    {{ goodDetail.schedule || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">长边宽</span>
                  <div class="NoWrap">
                    {{ goodDetail.outBreadth || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">规格</span>
                  <div class="NoWrap">
                    {{ goodDetail.guige || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">是否期货</span>
                  <div class="NoWrap">
                    {{ goodDetail.futuresFlag == "0" ? "现货" : "期货" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">批号</span>
                  <div class="NoWrap">
                    {{ goodDetail.batchNo || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">质量等级</span>
                  <div class="NoWrap">
                    {{ goodDetail.qualityLevel || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">生产工艺</span>
                  <div class="NoWrap">
                    {{ goodDetail.produceTechnology || "-" }}
                  </div>
                </li>
                <li>
                  <span class="colorGray959595">生产日期</span>
                  <div class="NoWrap">
                    {{ goodDetail.exFactoryDate || "-" }}
                  </div>
                </li>
              </ul>
            </div>
            <div style="border-top: 1px solid #eee" class="p_30">
              <div v-html="goodDetail.details"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showDetail2">
      <div style="opacity: 0.5" class="cover"></div>
      <div
        style="
          text-align: center;
          position: fixed;
          top: calc((100% - 670px) / 2.6);
          background-color: #fff;
          left: calc(50% - 350px);
          width: 700px;
          z-index: 1001;
        "
      >
        <div style="width: 100%; height: 600px" id="container"></div>
        <button
          @click="showDetail2 = false"
          style="margin: 20px"
          class="cancelButton"
        >
          返回
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import pubilshSet from '../../../../assets/js/pubilshSet'

let marker
let map
export default {
  name: 'myGoodsDetail',
  data () {
    return {
      isRegister: window.localStorage.getItem('memberId'),
      isBishiTime: false,
      MemberInfo: JSON.parse(window.localStorage.getItem('MemberInfo') || '{}'),
      goodDetail: {},
      selectImgIndex: 0,
      goodsImgList: [
        {
          id: 1,
          imgUrl: require('../../../../assets/img/backgroundImg.png')
        },
        {
          id: 2,
          imgUrl: require('../../../../assets/img/backgroundImg.png')
        },
        {
          id: 3,
          imgUrl: require('../../../../assets/img/backgroundImg.png')
        },
        {
          id: 4,
          imgUrl: require('../../../../assets/img/backgroundImg.png')
        }
      ],
      myGoodsInfoList: [
        {
          id: 1,
          letfName: '是否预售',
          name: '现货现货现货现货现货现货现货现货现货现货现货'
        },
        {
          id: 2,
          letfName: '是否预售',
          name: '现货现货现货现货现货现货现货现货现货现货现货'
        },
        {
          id: 3,
          letfName: '是否预售',
          name: '现货现货现货现货现货现货现货现货现货现货现货'
        },
        {
          id: 4,
          letfName: '是否预售',
          name: '现货现货现货现货现货现货现货现货现货现货现货'
        },
        {
          id: 5,
          letfName: '是否预售',
          name: '现货现货现货现货现货现货现货现货现货现货现货'
        },
        {
          id: 6,
          letfName: '是否预售',
          name: '现货现货现货现货现货现货现货现货现货现货现货'
        },
        {
          id: 7,
          letfName: '是否预售',
          name: '现货现货现货现货现货现货现货现货现货现货现货'
        },
        {
          id: 8,
          letfName: '是否预售',
          name: '现货现货现货现货现货现货现货现货现货现货现货'
        }
      ],
      WarehouseList: [],
      nowWareData: {},
      baigangToken: localStorage.getItem('baigangToken'),
      showDetail2: false,

      leftOffset: 0
    }
  },
  created () {
    document.title = '百钢商城 | 钢铁电商，百炼成钢'
    if (this.$route.query.id) {
      this.getGoodDetail()
    }
    // 检测闭市
    this.$commonJs.asyncReturnIsBishiTime().then(res => {
      this.isBishiTime = res
    })
  },
  methods: {
    toLogin () {
      window.location.href = pubilshSet.userCenterHostUrl + 'login'
    },
    addToShopCar () {
      // 闭市期间不能加入购物车
      if (this.isBishiTime) {
        this.$commonJs.alertTips({
          type: 'error',
          title: 'error',
          content: '现在是闭市时间,营业时间外不能下单',
          stayTime: 5
        })
        return false
      }
      this.$axiox.post('/baigang/buyer/center/addGoodToCart', {
        amount: this.goodDetail.amount,
        goodId: this.goodDetail.id,
        skuId: this.goodDetail.skuList[0].id
      }).then(p => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功:',
          content: '添加成功',
          stayTime: 5
        })
        // this.$store.commit('edit', {value: !that.$store.state.isRefreshShopCar,KeyName: 'isRefreshShopCar'})
        this.$refs.allMallSerch.getShopList()
      })
    },
    showDetailFun () {
      this.showDetail2 = true
      if (this.nowWareData) {
        this.$nextTick(p => {
          // eslint-disable-next-line no-undef
          map = new AMap.Map('container', {
            resizeEnable: true,
            center: [parseFloat(this.nowWareData.longitude), parseFloat(this.nowWareData.latitude)],
            zoom: 13
          })
          clearMarker()
          addMarker(parseFloat(this.nowWareData.longitude), parseFloat(this.nowWareData.latitude), this.nowWareData.name)
        })
      }
    },
    getGoodDetail () {
      this.$axiox.get('/baigang/app/good/getGoodInfo/' + this.$route.query.id).then(p => {
        p.data.amount = 1
        this.goodDetail = p.data
        // 设置主图
        this.goodDetail.imgList.find((item, index) => {
          // 1为主图
          if (item.masterImg === 1) {
            this.selectImgIndex = index
            this.moveGoImg('init', index)
            return true
          }
        })
        this.$axiox.post('/baigang/app/good/queryWarehouseList', { currPage: 1, pageSize: 9999 }).then(p => {
          this.WarehouseList = p.data.list
          this.nowWareData = this.WarehouseList.find(p => {
            return p.id === this.goodDetail.warehouseId
          })
        })
      })
    },
    countNum (type) {
      if (type === 'reduce') {
        if (this.goodDetail.amount > 1) {
          this.goodDetail.amount--
        }
      } else {
        if (this.goodDetail.amount < this.goodDetail.skuList[0].stock) {
          this.goodDetail.amount++
        }
      }
    },
    moveGoImg (type, index) {
      let base = 70
      let columnWdith = 370
      if (type) {
        if (type === 'pre') {
          if (this.leftOffset < 0) {
            this.leftOffset = this.leftOffset + base
          }
        }
        if (type === 'next') {
          let max = this.goodDetail.imgList.length * (base + 10) * -1 + columnWdith
          if (this.leftOffset > max) {
            this.leftOffset = this.leftOffset - base
          }
        }
        if (type === 'itemClick') {
          let offset = (index + 1) * (base + 10) * -1 + columnWdith
          if (offset < 0) {
            this.leftOffset = offset
          }
          if (offset > 0) {
            if (offset < columnWdith) {
              this.leftOffset = 0
            } else {
              this.leftOffset = this.leftOffset + offset
            }
          }
        }
        if (type === 'init') {
          let offset = (index + 1) * (base + 10) * -1 + columnWdith
          if (offset < 0) {
            this.leftOffset = offset
          }
          if (offset > 0) {
            if (offset < columnWdith) {
              this.leftOffset = 0
            } else {
              this.leftOffset = this.leftOffset + offset
            }
          }
        }
      }
    },
    hundleGoImgItemClick (index) {
      this.selectImgIndex = index
      this.moveGoImg('itemClick', index)
    }
  }
}
function clearMarker () {
  if (marker) {
    marker.setMap(null)
    marker = null
  }
}
function addMarker (x, y, name) {
  // eslint-disable-next-line no-undef
  marker = new AMap.Marker({
    icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
    position: [x, y],
    // eslint-disable-next-line no-undef
    offset: new AMap.Pixel(-13, -30)
  })
  var markerContent = document.createElement('div')

  // 点标记中的图标
  var markerImg = document.createElement('img')
  markerImg.className = 'markerlnglat'
  markerImg.src = '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png'
  markerContent.appendChild(markerImg)

  // 点标记中的文本
  var markerSpan = document.createElement('span')
  markerSpan.className = 'marker'
  markerSpan.innerHTML = name
  markerContent.appendChild(markerSpan)
  marker.setContent(markerContent)
  marker.setMap(map)
}
</script>

<style scoped>
.gmButton,
.gwButton {
  outline: none;
}
.gmButton {
  border: 2px solid #ed222c;
  width: 174px;
  height: 54px;
  background-color: white;
  color: #ed222c;
  font-size: 20px;
  padding: 0 40px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}
.gwButton {
  border: none;
  background-color: #ed222c;
  width: 174px;
  color: white;
  height: 54px;
  font-size: 20px;
  justify-content: center;
  align-items: center;
}
.gwButton > i {
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page/mySteelMall/myGoodsDetail.vue